import { ReactNode, useState, useCallback } from 'react'

import { ChatContext, INITIAL_STATE, ChatState } from './chatContext'

import ChatHelper from 'common/helpers/chat'
import { GetProfileResponse, GetConversationResponse } from '../types'

interface Props {
  children: ReactNode,
  state?: ChatState
}

export const ChatProvider = ({ children, state }: Props) => {
  const [showChat, setShowChat] = useState(ChatHelper.getShowChatStorage())
  const [isChatActive, setIsChatActive] = useState(INITIAL_STATE.isChatActive)
  const [viewers, setViewers] = useState(0)
  const [adminIds, setAdminIds] = useState<string[]>(INITIAL_STATE.adminIds)
  const [profile, setProfile] = useState<GetProfileResponse>(INITIAL_STATE.profile)
  const [conversation, setConversation] = useState<GetConversationResponse>(INITIAL_STATE.conversation)
  const [isLoaded, setIsLoaded] = useState(INITIAL_STATE.isLoaded)
  const [hasError, setHasError] = useState(INITIAL_STATE.hasError)
  const [isLoading, setIsLoading] = useState(INITIAL_STATE.isLoading)
  const [isMuted, setIsMuted] = useState(INITIAL_STATE.isMuted)

  const isChatVisible = showChat && isChatActive

  const handleSetShowChat = useCallback((value: boolean) => {
    setShowChat(value)
    localStorage.setItem('chat', `${value}`)
  }, [])

  return (
    <ChatContext.Provider value={{
      showChat,
      setShowChat: handleSetShowChat,
      isChatActive,
      setIsChatActive,
      isChatVisible,
      viewers,
      setViewers,
      adminIds,
      setAdminIds,
      profile,
      setProfile,
      conversation,
      setConversation,
      isLoaded,
      setIsLoaded,
      hasError,
      setHasError,
      isLoading,
      setIsLoading,
      isMuted,
      setIsMuted,
      ...state
    }}>
      {children}
    </ChatContext.Provider>
  )
}
